import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for transport zones
 */
export class TransportZoneService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.TransportZones.TransportZoneResponse | InterACT.Interfaces.TransportZones.TransportZonesResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/transport-zones/:zoneId', undefined, { update: { method: 'PUT' } });
  }

  /**
   * Function to create a transport zone
   *
   * @param transportZone An object representation of a transport zone
   * @returns A promise that resolves when the create operation is completed
   */
  public create(transportZone: InterACT.Interfaces.TransportZones.TransportZone) {
    return this.resource.save(transportZone).$promise;
  }

  /**
 * Retrieves a single transport zone with the supplied id
 * @param id the id of the transport zone to retrieve
 * @return a promise that resolves with a transport zone response
 */
  public get(id: string): ng.IPromise<InterACT.Interfaces.TransportZones.TransportZoneResponse> {
    return <ng.IPromise<InterACT.Interfaces.TransportZones.TransportZoneResponse>>this.resource.get({ zoneId: id }).$promise;
  }

  /**
 * Function to update a transport zone
 *
 * @param transportZone An object representation of the transport zone resource to be updated
 * @returns The http promise that resolves once the service interaction is complete
 */
  public update(transportZone: InterACT.Interfaces.TransportZones.TransportZone) {
    return (<any>this.resource).update({ zoneId: transportZone.id }, transportZone).$promise;
  }

  /**
  * Function to delete a transport zone
  *
  * @param transportZoneId The id of the transport zone to delete
  * @returns The http promise that resolves once the service interaction is complete
  */
  public delete(transportZoneId: string) {
    return this.resource.delete({ zoneId: transportZoneId }).$promise;
  }

  /**
 * Function to retrieve a list of transport zones
 *
 * @param page The number of the page of data to be retrieved
 * @param perPageCount The number of items per page to be retrieved
 * @param query the query to execute against the dataset
 * @returns A http promise that resolves with a transport zones response
 */
  public getList(page: number, perPageCount: number, query?: string): ng.IPromise<InterACT.Interfaces.TransportZones.TransportZonesResponse> {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.TransportZones.TransportZonesResponse>>this.resource.get(options).$promise;
  }
}
